import http from "@/http-common.js";

class MenuService {
  basePathApiService = "/menu";
  getAll() {
    return http.get(this.basePathApiService, {params: {limit: 10000}});
  }
}
export default new MenuService();
